import styled, { css } from 'styled-components';
import { theme } from '../../theme';

const { colors, shadows } = theme;

export const DivWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  z-index: 1061;
  background: rgba(25, 21, 69, 0.9);
`;

export const DivImageWrapper = styled.div`
  position: relative;
  background: ${colors.white};
  box-shadow: ${shadows.tableInfoPopover};
  border-radius: 5px;
  z-index: 1062;
  padding: 15px;
  min-height: 200px;
  min-width: 200px;
  max-height: calc(100vh - 40px);
  max-width: calc(100vw - 40px);
  transition: all 1s;

  button {
    position: absolute;
    width: 40px;
    height: 40px;
    right: 0;
    top: 0;
    padding: 0;
    outline: none;
    border: none;
    background-color: ${colors.white};
    font-size: 1.3rem;
    cursor: pointer;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
  }

  img {
    max-width: calc(100vw - 70px);
    max-height: calc(100vh - 70px);
  }
`;

export const DivPrevNext = styled.div<{ isPrev?: boolean }>`
  position: absolute;
  top: 50%;
  right: ${(props) => (props.isPrev ? 'auto' : '10px')};
  left: ${(props) => (props.isPrev ? '10px' : 'auto')};
  outline: none;
  border: none;
  background-color: ${colors.white};
  cursor: pointer;
  font-size: 2.5rem;
  width: 3.5rem;
  margin-top: -1.6rem;
  text-align: center;
  opacity: 0.6;
  z-index: 1052;
  &:hover {
    opacity: 1;
  }
`;

export const ImgPreview = styled.img`
    user-select: none !important;
    -webkit-user-drag: none;
`;

export const ButtonClose = styled.button`
    z-index: 1052;
`;

export const DivLabel = styled.div`
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translate(-50%);
  color: ${colors.textPrimary};
  font-size: 14px;
  font-weight: 500;
  padding: 15px;
  background: ${colors.white};
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
`;
